import store from 'store'

const increment = store.getActions().datadog.increment
let initialized = false

function poll(fn: any, timeout = 2000, interval = 100) {
  var endTime = Number(new Date()) + timeout

  var checkCondition = function (resolve: any, reject: any) {
    // If the condition is met, we're done!
    var result = fn()
    if (result) {
      resolve(result)
    }
    // If the condition isn't met but the timeout hasn't elapsed, go again
    else if (Number(new Date()) < endTime) {
      setTimeout(checkCondition, interval, resolve, reject)
    }
    // Didn't match and too much time, reject!
    else {
      reject(new Error('timed out for ' + fn + ': ' + arguments))
    }
  }

  return new Promise(checkCondition)
}

export default function preampReady(cb: any, failCb: any) {
  // if running in test, development, or cypress environment just fire callback
  if (['development', 'test'].includes(process.env.REACT_APP_ENV!) || window.Cypress) {
    if (!initialized) {
      initialized = true
      return cb()
    }
  }

  poll(() => {
    // @ts-ignore // prevent cohesion doesn't exist on window TS error
    return !!(window && window.cohesion)
  })
    .then(() => {
      // @ts-ignore
      window.cohesion('preamp:done', function (preAmpOutcome) {
        setTimeout(() => {
          if (!initialized) {
            console.log('done')
            initialized = true
            cb(preAmpOutcome)
          }
        }, 100)
      })
      // @ts-ignore
      window.cohesion('preamp:error', function () {
        if (!initialized) {
          console.log('error')
          initialized = true
          increment({ name: 'initialized.error', value: 1 })
          failCb()
        }
      })
    })
    .catch(() => {
      if (!initialized) {
        console.log('catch')
        initialized = true
        increment({ name: 'initialized.catch', value: 1 })
        failCb()
      }
    })

  setTimeout(() => {
    if (!initialized) {
      console.log('timeout')
      initialized = true
      increment({ name: 'initialized.fallback', value: 1 })
      failCb()
    }
    // Slightly bigger than the poll timeout
  }, 5000)
}
